import { Chip, Tooltip } from "@mui/material";
import { PolicyOrAccount } from "../../../interfaces/DTO/mislaka_xml_models";


interface Props {
  policies: PolicyOrAccount[];
}

export const LegalLimitChip = ({ policies }: Props) => {
  const hasLien = policies.some(
    (p) => p.legal_limit_status === 11 || p.legal_limit_status === 13
  );
  const hasForeclosure = policies.some(
    (p) => p.legal_limit_status === 12 || p.legal_limit_status === 13
  );

  return (
    <>
      {hasLien && (
        <Tooltip title="שיעבוד" arrow placement="top">
          <Chip
            label="שיעבוד"
            size="small"
            variant="outlined"
            sx={{
              cursor: "default",
            //   fontSize: "0.875rem",
              borderColor: "#FFA726", // כתום (warning)
              color: "#FFA726",
            }}
          />
        </Tooltip>
      )}
      {hasForeclosure && (
        <Tooltip title="עיקול" arrow placement="top">
          <Chip
            label="עיקול"
            size="small"
            variant="outlined"
            sx={{
              cursor: "default",
            //   fontSize: "0.875rem",
              borderColor: "#EF5350", // אדום (error)
              color: "#EF5350",
            }}
          />
        </Tooltip>
      )}
    </>
  );
};
